import React, {useMemo} from 'react';
import styled from 'styled-components';
import {Transition} from 'react-transition-group';
import PropTypes from 'prop-types';


const timeout = {
  appear: 0,
  enter: 0,
  exit: 500
};

const Mask = styled.div`
    z-index: 1000;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.55);
    transition: opacity 500ms cubic-bezier(0.77,0.2,0.05,1.0);
    opacity: ${({state}) => {
  /* state change: exited -> entering -> entered -> exiting -> exited*/
  switch (state) {
    case "entering":
      return 0.01;
    case "entered":
      return 1;
    case "exiting":
      return 0.01;
    case "exited":
      return 0.00;
    default:
      return 0;
  }
}};
`;
const Content = styled.div`
    z-index: 1001;
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 16px;
    border-radius: 3px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    transition: box-shadow 0.3s cubic-bezier(.25,.8,.25,1);
    &:hover {
      box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 1.2em;
  margin: 0 0 10px 0;
`;
const Desc = styled.div`
  color: #686868;
  margin: 0 5px;
`;
const Choices = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const Choice = styled.div`
  cursor: pointer;
  padding: 10px;
  margin: 0 0 -10px 0;
  ${({primary}) => primary 
    ? `
      color: var(--ls-color-1);
      font-weight: 600;
    `
    : `
      color: var(--ls-color-2);
    `
  };
  
  &:hover {
    background-color: rgba(25, 118, 210, 0.08);
  }
`;

const PromptDialog = ({prompt, clearPrompt}) => {
  const {choices, title, desc} = prompt;
  const choicesComp = useMemo(() => {
    return choices.map(({label, onClick, primary}) => {
      return (
        <Choice
          onClick={() => {
            clearPrompt();
            if (onClick) {
              onClick(prompt);
            }
          }}
          key={`${label}-${primary}`}
          primary={primary}
        >
          {label}
        </Choice>
      );
    });
  }, [prompt, choices, clearPrompt]);

  const active = !!prompt;

  return (
    <>
      {active && (
        <Content>
          <Title>{typeof title === 'function' ? title({clearPrompt}) : title}</Title>
          <Desc>{typeof desc === 'function' ? desc({clearPrompt}) : desc}</Desc>
          <Choices>
            {choicesComp}
          </Choices>
        </Content>
      )}
      <Transition
        in={active}
        timeout={timeout}
        unmountOnExit
        mountOnEnter>
          {(state) => <Mask state={state}/>}
      </Transition>
    </>
  );
};

PromptDialog.propTypes = {
  prompt: PropTypes.shape({
    title: PropTypes.string,
    desc: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    choices: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      primary: PropTypes.bool,
    })).isRequired,
  }),
  clearPrompt: PropTypes.func,
};
export default PromptDialog;
